import { resolveComponent as _resolveComponent, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, createVNode as _createVNode, createElementBlock as _createElementBlock, withModifiers as _withModifiers } from "vue"

const _hoisted_1 = {
  class: "modal fade",
  id: "modal_add_user",
  tabindex: "-1",
  "data-bs-backdrop": "static",
  "aria-hidden": "true"
}
const _hoisted_2 = { class: "modal-dialog modal-lg" }
const _hoisted_3 = { class: "modal-content position-relative" }
const _hoisted_4 = { class: "modal-header" }
const _hoisted_5 = {
  class: "modal-title",
  id: "varyingModalLabel"
}
const _hoisted_6 = {
  key: 1,
  class: "modal-body"
}
const _hoisted_7 = { class: "row" }
const _hoisted_8 = { class: "row mb-3" }
const _hoisted_9 = { class: "col-md-6 mb-2" }
const _hoisted_10 = { class: "col-md-6 mb-2" }
const _hoisted_11 = { class: "row mb-4" }
const _hoisted_12 = {
  key: 0,
  class: "col-md-12 mb-3"
}
const _hoisted_13 = { class: "form-group mr-b-0em" }
const _hoisted_14 = {
  key: 1,
  class: "col-md-12"
}
const _hoisted_15 = { class: "col-md-6" }
const _hoisted_16 = { class: "form-group" }
const _hoisted_17 = { class: "col-md-6" }
const _hoisted_18 = { class: "form-group" }
const _hoisted_19 = { class: "col-md-6" }
const _hoisted_20 = { class: "form-group" }
const _hoisted_21 = { class: "col-md-6" }
const _hoisted_22 = { class: "form-group" }
const _hoisted_23 = {
  key: 0,
  class: "col-md-6"
}
const _hoisted_24 = { class: "form-group" }
const _hoisted_25 = {
  key: 1,
  class: "col-md-6"
}
const _hoisted_26 = { class: "form-group" }
const _hoisted_27 = { class: "col-md-6" }
const _hoisted_28 = { class: "form-group" }
const _hoisted_29 = {
  key: 2,
  class: "col-md-12"
}
const _hoisted_30 = { class: "row" }
const _hoisted_31 = { class: "col-md-6 text-right" }
const _hoisted_32 = { class: "col-md-6 text-right" }
const _hoisted_33 = {
  type: "submit",
  class: "w-100 btn btn-primary mr-2"
}

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_loader_gif = _resolveComponent("loader-gif")!
  const _component_radioInput = _resolveComponent("radioInput")!
  const _component_input_image = _resolveComponent("input-image")!
  const _component_capture_photo = _resolveComponent("capture-photo")!
  const _component_inputText = _resolveComponent("inputText")!
  const _component_phone_number = _resolveComponent("phone-number")!
  const _component_SingleSelect = _resolveComponent("SingleSelect")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("div", _hoisted_2, [
      _createElementVNode("div", _hoisted_3, [
        (_ctx.isRequestUser)
          ? (_openBlock(), _createBlock(_component_loader_gif, { key: 0 }))
          : _createCommentVNode("", true),
        _createElementVNode("div", _hoisted_4, [
          _createElementVNode("h5", _hoisted_5, _toDisplayString(_ctx.modalTitle), 1),
          _createElementVNode("button", {
            onClick: _cache[0] || (_cache[0] = ($event: any) => (_ctx.closeModal('modal_add_user', 'add'))),
            type: "button",
            class: "btn-close",
            "aria-label": "btn-close"
          })
        ]),
        (_ctx.requestUser)
          ? (_openBlock(), _createElementBlock("div", _hoisted_6, [
              _createElementVNode("form", {
                class: "forms-sample",
                onSubmit: _cache[14] || (_cache[14] = _withModifiers(
//@ts-ignore
(...args) => (_ctx.submitForm && _ctx.submitForm(...args)), ["prevent"]))
              }, [
                _createElementVNode("div", _hoisted_7, [
                  _createElementVNode("div", _hoisted_8, [
                    _createElementVNode("div", _hoisted_9, [
                      _createVNode(_component_radioInput, {
                        modelValue: _ctx.isCaputre,
                        "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event: any) => ((_ctx.isCaputre) = $event)),
                        valueAttr: 1,
                        label: _ctx.i18n.t('button.upload_image'),
                        name: `isCaputre`,
                        id: `isCaputre-1`
                      }, null, 8, ["modelValue", "label"])
                    ]),
                    _createElementVNode("div", _hoisted_10, [
                      _createVNode(_component_radioInput, {
                        modelValue: _ctx.isCaputre,
                        "onUpdate:modelValue": _cache[2] || (_cache[2] = ($event: any) => ((_ctx.isCaputre) = $event)),
                        valueAttr: 0,
                        label: _ctx.i18n.t('button.take_photo'),
                        name: `isCaputre`,
                        id: `isCaputre-0`
                      }, null, 8, ["modelValue", "label"])
                    ])
                  ]),
                  _createElementVNode("div", _hoisted_11, [
                    (_ctx.isCaputre)
                      ? (_openBlock(), _createElementBlock("div", _hoisted_12, [
                          _createElementVNode("div", _hoisted_13, [
                            _createVNode(_component_input_image, {
                              modelValue: _ctx.requestUser.path_image,
                              "onUpdate:modelValue": _cache[3] || (_cache[3] = ($event: any) => ((_ctx.requestUser.path_image) = $event)),
                              label: _ctx.i18n.t('tables.members.name'),
                              pathImage: _ctx.requestUser.path_image,
                              disabled: false
                            }, null, 8, ["modelValue", "label", "pathImage"])
                          ])
                        ]))
                      : _createCommentVNode("", true),
                    (!_ctx.isCaputre)
                      ? (_openBlock(), _createElementBlock("div", _hoisted_14, [
                          _createVNode(_component_capture_photo, {
                            modelValue: _ctx.requestUser.path_image,
                            "onUpdate:modelValue": _cache[4] || (_cache[4] = ($event: any) => ((_ctx.requestUser.path_image) = $event)),
                            pathImage: _ctx.requestUser.path_image,
                            v: _ctx.v$.path_image
                          }, null, 8, ["modelValue", "pathImage", "v"])
                        ]))
                      : _createCommentVNode("", true)
                  ]),
                  _createElementVNode("div", _hoisted_15, [
                    _createElementVNode("div", _hoisted_16, [
                      _createVNode(_component_inputText, {
                        modelValue: _ctx.requestUser.firstName,
                        "onUpdate:modelValue": _cache[5] || (_cache[5] = ($event: any) => ((_ctx.requestUser.firstName) = $event)),
                        label: _ctx.i18n.t('tables.users.firstName'),
                        v: _ctx.v$.firstName,
                        disabled: false
                      }, null, 8, ["modelValue", "label", "v"])
                    ])
                  ]),
                  _createElementVNode("div", _hoisted_17, [
                    _createElementVNode("div", _hoisted_18, [
                      _createVNode(_component_inputText, {
                        modelValue: _ctx.requestUser.lastName,
                        "onUpdate:modelValue": _cache[6] || (_cache[6] = ($event: any) => ((_ctx.requestUser.lastName) = $event)),
                        label: _ctx.i18n.t('tables.users.lastName'),
                        v: _ctx.v$.lastName,
                        disabled: false
                      }, null, 8, ["modelValue", "label", "v"])
                    ])
                  ]),
                  _createElementVNode("div", _hoisted_19, [
                    _createElementVNode("div", _hoisted_20, [
                      _createVNode(_component_inputText, {
                        modelValue: _ctx.requestUser.email,
                        "onUpdate:modelValue": _cache[7] || (_cache[7] = ($event: any) => ((_ctx.requestUser.email) = $event)),
                        label: _ctx.i18n.t('tables.users.email'),
                        v: _ctx.v$.email,
                        disabled: false
                      }, null, 8, ["modelValue", "label", "v"])
                    ])
                  ]),
                  _createElementVNode("div", _hoisted_21, [
                    _createElementVNode("div", _hoisted_22, [
                      _createVNode(_component_phone_number, {
                        modelValue: _ctx.requestUser.phone,
                        "onUpdate:modelValue": _cache[8] || (_cache[8] = ($event: any) => ((_ctx.requestUser.phone) = $event)),
                        label: _ctx.i18n.t('tables.users.phone'),
                        v: _ctx.v$.phone,
                        disabled: false
                      }, null, 8, ["modelValue", "label", "v"])
                    ])
                  ]),
                  (_ctx.action == 'add')
                    ? (_openBlock(), _createElementBlock("div", _hoisted_23, [
                        _createElementVNode("div", _hoisted_24, [
                          _createVNode(_component_inputText, {
                            modelValue: _ctx.requestUser.password,
                            "onUpdate:modelValue": _cache[9] || (_cache[9] = ($event: any) => ((_ctx.requestUser.password) = $event)),
                            label: _ctx.i18n.t('tables.users.password'),
                            v: _ctx.v$.password,
                            disabled: false
                          }, null, 8, ["modelValue", "label", "v"])
                        ])
                      ]))
                    : _createCommentVNode("", true),
                  (_ctx.action == 'add')
                    ? (_openBlock(), _createElementBlock("div", _hoisted_25, [
                        _createElementVNode("div", _hoisted_26, [
                          _createVNode(_component_inputText, {
                            modelValue: _ctx.requestUser.password_confirmation,
                            "onUpdate:modelValue": _cache[10] || (_cache[10] = ($event: any) => ((_ctx.requestUser.password_confirmation) = $event)),
                            label: _ctx.i18n.t('tables.users.password_confirmation'),
                            v: _ctx.v$.password_confirmation,
                            disabled: false
                          }, null, 8, ["modelValue", "label", "v"])
                        ])
                      ]))
                    : _createCommentVNode("", true),
                  _createElementVNode("div", _hoisted_27, [
                    _createElementVNode("div", _hoisted_28, [
                      _createVNode(_component_inputText, {
                        modelValue: _ctx.requestUser.pin,
                        "onUpdate:modelValue": _cache[11] || (_cache[11] = ($event: any) => ((_ctx.requestUser.pin) = $event)),
                        label: _ctx.i18n.t('tables.users.pin'),
                        v: _ctx.v$.pin,
                        disabled: false
                      }, null, 8, ["modelValue", "label", "v"])
                    ])
                  ]),
                  (_ctx.action == 'add')
                    ? (_openBlock(), _createElementBlock("div", _hoisted_29, [
                        _createVNode(_component_SingleSelect, {
                          TextLabel: _ctx.i18n.t('tables.users.roles'),
                          trackby: `name`,
                          label: `name`,
                          valueProp: `name`,
                          modelValue: _ctx.requestUser.roles,
                          "onUpdate:modelValue": _cache[12] || (_cache[12] = ($event: any) => ((_ctx.requestUser.roles) = $event)),
                          placeholder: _ctx.i18n.t('tables.users.seller'),
                          arrayOptions: [{ id: 1, name: 'assistance' }],
                          refs: "sellers",
                          v: _ctx.v$.roles
                        }, null, 8, ["TextLabel", "modelValue", "placeholder", "v"])
                      ]))
                    : _createCommentVNode("", true)
                ]),
                _createElementVNode("div", _hoisted_30, [
                  _createElementVNode("div", _hoisted_31, [
                    _createElementVNode("button", {
                      type: "button",
                      onClick: _cache[13] || (_cache[13] = ($event: any) => (_ctx.closeModal('modal_add_user', 'add'))),
                      class: "w-100 btn btn-cancel"
                    }, _toDisplayString(_ctx.i18n.t('button.close')), 1)
                  ]),
                  _createElementVNode("div", _hoisted_32, [
                    _createElementVNode("button", _hoisted_33, _toDisplayString(_ctx.action == 'add' ? _ctx.i18n.t('button.add') : _ctx.i18n.t('button.edit')), 1)
                  ])
                ])
              ], 32)
            ]))
          : _createCommentVNode("", true)
      ])
    ])
  ]))
}